// First-touch lead attribution — captured once per browser session.
// Stored in sessionStorage so a lead submitted from ANY page keeps the
// original landing page, referrer and campaign parameters.
const KEY = "zd_attr";

export function getAttribution() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (cached) return cached;
    const q = new URLSearchParams(window.location.search);
    const attr = {
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || "",
      utm_source: q.get("utm_source") || "",
      utm_medium: q.get("utm_medium") || "",
      utm_campaign: q.get("utm_campaign") || "",
      gclid: q.get("gclid") || "",
    };
    sessionStorage.setItem(KEY, JSON.stringify(attr));
    return attr;
  } catch (_) {
    return {};
  }
}
